import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import WebsiteNotificationBar from '../components/WebsiteNotificationBar';
import { setLoginState } from '../actions/Login';
import { login } from '../actions/User';
import LoginForm from '../components/Login';
import { ReactComponent as EpikLogoSvg } from '../Res/granite-logo.svg';
import './login.css';
import { Alert } from 'reactstrap';

class Login extends Component {
  render() {
    const { user } = this.props;
    if (user.isLoggedIn === false && user.error === "User Disable") {
      return (
        <div className="container main-container">
          <WebsiteNotificationBar isOpen={process.env.REACT_APP_TICKER_STATUS === 'true'}>
            {process.env.REACT_APP_TICKER_TEXT}
          </WebsiteNotificationBar>

          <div className="login-container">
            <div className="col-12 d-flex align-self-start">
              <EpikLogoSvg width={120} height={60} />
            </div>

            <div className="col-12 text-left" style={{ marginTop: '30px', minHeight: '50vh' }}>
              <h5>Login</h5>
              <p style={{ color: '#8998ac' }}>Please enter your email and password to proceed</p>
              <LoginForm
                onLogin={this.props.loginUser}
                onLoginDataChange={this.props.setLoginState}
                username={this.props.UIState.username}
                password={this.props.UIState.password}
                type="simpleLogin"
                error={user.isLoggedIn}
              />
               <Alert color="danger">
                <p>
                  Your account has been disabled due to inactivity. Please contact Granite Support Desk to have your account re-activated. To avoid this in the future, please login to the MyEPIK portal at least once every 90 days.
                </p>
              </Alert>
            </div>
            <div className="col-12 d-flex">
              <Link to="/account-request" style={{ color: '#8998ac' }}>
                New Account Request
              </Link>
            </div>
          </div>
        </div>
      );
    }
    if (user && user._id) {
      return <Redirect to="/" />;
    }
    const { username, password } = this.props.UIState;
    return (
      <div className="container main-container">
        <WebsiteNotificationBar isOpen={process.env.REACT_APP_TICKER_STATUS === 'true'}>
          {process.env.REACT_APP_TICKER_TEXT}
        </WebsiteNotificationBar>
        <div className="login-container">
          <div className="col-12 d-flex align-self-start">
            <EpikLogoSvg width={120} height={60} />
          </div>

          <div className="col-12 text-left" style={{ marginTop: '30px', minHeight: '50vh' }}>
            <h5>Login</h5>
            <p style={{ color: '#595959' }}>Please enter your email and password to proceed</p>
            <LoginForm
              onLogin={this.props.loginUser}
              onLoginDataChange={this.props.setLoginState}
              username={username}
              password={password}
              type="simpleLogin"
            />
          </div>
          <div className="col-12 d-flex">
            <Link to="/account-request" style={{ color: '#8998ac' }}>
              New Account Request
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  UIState: {
    username: state.UIState.loginForm.username,
    password: state.UIState.loginForm.password,
  },
  user: state.AppState.user,
});

const mapDispatchToProps = dispatch => ({
  setLoginState: (username, password) => dispatch(setLoginState(username, password)),
  loginUser: (username, password) => dispatch(login(username, password)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Login);
